import { useRouter } from 'next/router';
import React, { useEffect } from 'react';
import { ROUTES, ROUTES_DESCRIPTION, ROUTES_REGEX } from '~/constants/ROUTES';
import { isRegexPathEquivalent } from '~/helpers/path';
const RouteAnnouncer: React.FC = () => {
  const router = useRouter();
  useEffect(() => {
    const routeKey = Object.keys(ROUTES_REGEX).find(roueKey => isRegexPathEquivalent(ROUTES_REGEX[roueKey as keyof typeof ROUTES], router.asPath));
    const routeDescription = ROUTES_DESCRIPTION[routeKey as keyof typeof ROUTES_DESCRIPTION];
    document.title = routeDescription;
  }, [router]);
  return null;
};
export default RouteAnnouncer;